export default __webpack_public_path__ + "sports.0138ec67963e3fde6e905c79612239b9.png";